function getToken(){
   let token = localStorage.getItem('token');
   if(token){
      return JSON.parse(token);
   }
}

export default getToken;